<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formWalletBalance">
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col field-company">
              <app-custom-autocomplete formControlName="companyId" [labelText]="'Compañía'" [list]="listCompanies"
                [required]="true" [recovery]="true">
              </app-custom-autocomplete>
            </div>
            <div class="col field-date">
              <app-custom-datepicker formControlName="date" [labelText]="'Periodo'" [required]="true"
                [dateFormat]="'MM - yy'" [placeholderFormat]="'Mes - año'">
              </app-custom-datepicker>
            </div>
            <div class="col field-insert-invoice my-2 my-sm-0 checkbox-container d-flex align-items-end gap-2">
              <app-custom-checkbox formControlName="insertInvoices" [labelText]="'Inserta Facturas'"
                class="mb-1"></app-custom-checkbox>

              <app-custom-button [title]="'Información.'" [severity]="'secondary'" [icon]="'pi pi-info-circle'"
                (onClick)="openToggle($event)"></app-custom-button>
              <p-popover #information>
                <div class="">
                  <span>
                    <b>Si NO Inserta Facturas:</b> Reconstruye los movimientos del período
                    <br> ingresado sin afectar los saldos iniciales del mismo y reconstruye
                    <br> los movimientos de los períodos posteriores.
                    <br>
                    <br>
                    <b>Si Inserta Facturas:</b>Elimina todos los datos que hay en saldo cartera,
                    <br>para luego insertar el SALDO de las facturas con fecha anterior
                    <br> al período ingresado como saldo inicial del período, como saldo inicial
                    <br>del período, y finaliza reconstruyendo los movimientos de ese período
                    <br>y los períodos posteriores.
                    <br>
                    <br>
                    <b>NOTA IMPORTANTE: </b>Se recomienda solo marcar el SW
                    <br>cuando se está montando cartera desde cero a una compañía, de resto
                    <br>NO se recomienda marcar el sw.
                  </span>
                </div>
              </p-popover>
            </div>
            <div class="col field-button d-flex align-items-end gap-2 mt-2">
              <app-custom-button [label]="'Procesar'" [severity]="'primary'" [disabled]="!permissionUpdatable"
                [variant]="undefined" (onClick)="processWalletBalance()" [width]="'5rem'"></app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>